// T.C. vatandaşı / yabancı uyruklu seçimi; yabancıda tc_kimlik_no alanı pasaport no olarak kullanılır
export const isForeign = (e) => e?.nationality === 'yabanci';
export const idNoLabel = (e) => (isForeign(e) ? 'Pasaport No' : 'T.C. Kimlik No');
export const cleanPassport = (v) => v.toUpperCase().replace(/[^A-Z0-9]/g, '');

export const NationalityToggle = ({ value = 'tc', onChange, testPrefix = 'nationality' }) => (
  <div className="inline-flex rounded-lg border border-slate-200 bg-slate-50 p-0.5" role="radiogroup" data-testid={`${testPrefix}-toggle`}>
    {[['tc', 'T.C. Vatandaşı'], ['yabanci', 'Yabancı Uyruklu']].map(([v, label]) => (
      <button key={v} type="button" role="radio" aria-checked={value === v} onClick={() => onChange(v)} data-testid={`${testPrefix}-${v}`}
        className={`rounded-md px-3 py-1 text-xs font-semibold transition-colors ${value === v ? 'bg-white text-slate-900 shadow-sm ring-1 ring-slate-200' : 'text-slate-500 hover:text-slate-800'}`}>
        {label}
      </button>
    ))}
  </div>
);

export const PassportTag = ({ employee }) => (isForeign(employee) ? (
  <span className="ml-1 rounded bg-indigo-100 px-1 py-px align-middle text-[9px] font-bold uppercase tracking-wide text-indigo-700" title="Yabancı uyruklu – pasaport no" data-testid={`passport-tag-${employee.id}`}>Pasaport</span>
) : null);
